import {remoteForm} from '@github-ui/remote-form'

remoteForm('.js-user-sessions-revoke', async function (form, wants) {
  await wants.text()

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const container = form.closest<HTMLElement>('.js-user-sessions-container')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const item = form.closest<HTMLElement>('.js-user-session')!
  item.remove()

  if (container) {
    const count = container.querySelectorAll('.js-user-session').length
    container.classList.toggle('has-active-sessions', count > 0)
  }
})
